import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  eachDayOfInterval,
  eachMonthOfInterval,
  format,
  startOfDay,
  startOfMonth,
} from 'date-fns';
import { ChartFileInfo } from '../../features/admin/domain/models/file/chart-file-info';

export function getChartSeriesFromFiles(
  files$: Observable<ChartFileInfo[]>,
  startDate: Date,
  endDate: Date,
): Observable<ChartData> {
  return files$.pipe(
    map((files) => {
      const start = new Date(startDate);
      const end = new Date(endDate);

      const isSingleMonth =
        start.getMonth() === end.getMonth() &&
        start.getFullYear() === end.getFullYear();

      const intervals = isSingleMonth
        ? eachDayOfInterval({
            start: startOfDay(start),
            end: startOfDay(end),
          })
        : eachMonthOfInterval({
            start: startOfMonth(start),
            end: startOfMonth(end),
          });

      const labels = intervals.map((date) =>
        format(date, isSingleMonth ? 'dd/MM' : 'MMM yyyy'),
      );
      const keys = intervals.map((date) =>
        isSingleMonth ? startOfDay(date) : startOfMonth(date),
      );

      const gerber = new Array(keys.length).fill(0);
      const lectra = new Array(keys.length).fill(0);

      for (const file of files ?? []) {
        const fileDate = isSingleMonth
          ? startOfDay(new Date(file.createdAt))
          : startOfMonth(new Date(file.createdAt));

        const index = keys.findIndex(
          (key) => key.getTime() === fileDate.getTime(),
        );
        if (index >= 0) {
          if (file.fileType === 'Gerber') gerber[index]++;
          if (file.fileType === 'Lectra') lectra[index]++;
        }
      }

      return {
        labels,
        series: [
          { name: 'Gerber', data: gerber },
          { name: 'Lectra', data: lectra },
        ],
      };
    }),
  );
}

export interface ChartData {
  labels: string[];
  series: { name: string; data: number[] }[];
}
